import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';

@Component({
  selector: 'app-pricing-table',
  templateUrl: './pricing-table.component.html',
  styleUrl: './pricing-table.component.css'
})
export class PricingTableComponent {
  // Pricing Plans
  pricingPlans = [
    {
      id: 1,
      name: 'Basic Plan',
      price: '$29.99',
      features: [
        'Up to 5 Projects',
        '5GB Storage',
        'Basic Support',
        'Monthly Updates',
        'Community Access'
      ]
    },
    {
      id: 2,
      name: 'Professional',
      price: '$79.99',
      features: [
        'Unlimited Projects',
        '500GB Storage',
        'Priority Support',
        'Weekly Updates',
        'Advanced Analytics',
        'Team Collaboration'
      ]
    },
    {
      id: 3,
      name: 'Enterprise',
      price: '$199.99',
      features: [
        'Custom Solutions',
        'Unlimited Storage',
        '24/7 Support',
        'Real-time Updates',
        'Advanced Analytics',
        'Custom Integration',
        'Dedicated Account Manager'
      ]
    }
  ];

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  // EmailJS service configuration
  private serviceId = 'helifax-form';  // Replace with your EmailJS Service ID
  private templateId = 'helifax-form';  // Replace with your EmailJS Template ID
  private publicKey = 'dOfh1ImCGDZCO9GJb';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }
}
